import React, { Component } from 'react';
import { Button, ButtonToolbar, ToggleButtonGroup, ToggleButton, Modal, Glyphicon, Tooltip, OverlayTrigger } from 'react-bootstrap';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { contractReviewerActions as actions } from '../../actions';
import Viewer from '../../helpers/documentViewer';
import DocumentHtmlView from '../DocumentViewer/DocumentHtmlView';
import ExportHOCRView from '../DocumentViewer/ExportHOCRView';

import HighlightExportTexts from '../Highlight/HighlightExportTexts';
import '../../content/css/ExportDocumentModal.css';
import ToggleSwitch from '../ToggleSwitch';
import LoadingListener from '../../helpers/loadingListener';
import { LoadingIcon } from '../LoadingIcon';
import { contractReviewerConstants } from '../../constants';

var download_icon = require("../../content/images/download_icon.png");
const HIGHLIGHT_SECTIONS = { GUIDANCE: 0, EXAMPLES: 1, EXPLANATION: 2, APPROVAL: 3, NOTES: 4, MISSING_CLAUSES: 5 };

class ExportDocumentModal extends Component {
    constructor(props, context) {
        super(props, context);

        this.handleShow = this.handleShow.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handlePrintClick = this.handlePrintClick.bind(this);
        this.handleExportAsWord = this.handleExportAsWord.bind(this);
        this.handleSectionToggle = this.handleSectionToggle.bind(this);
        this.handleSelectionToggle = this.handleSelectionToggle.bind(this);

        this.loadingListener = new LoadingListener([contractReviewerConstants.EXPORT_AS_DOCX_REQUEST, contractReviewerConstants.EXPORT_AS_EXCEL_REQUEST]);

        this.state = {
            show: false,
            isHOCRReady: false,
            wantToPrintPDF: false,
            highlights: [],
            filter: 1,
            visibleSections: [4]
        };
    }

    componentDidMount() {
        if (this.getCurrentDocument().highlights.length != 0) {
            this.filterHighlights();
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        let oldDoc = prevProps.analyzedDocuments[this.props.id];
        let oldHighlights = oldDoc ? oldDoc.highlights : [];
        let doc = this.getCurrentDocument();
        let hasNoSegments = doc.highlights.length == 0 && oldHighlights.length == 0;
        if (!hasNoSegments && this.getCurrentDocument().highlights !== oldHighlights) {
            this.filterHighlights();
        }

        if (this.state.highlights !== prevState.highlights) {
            Viewer.highlight(this.state.highlights, document.querySelector(".export-document-container .document-html"));
        }

        if (this.state.filter !== prevState.filter) {
            this.filterHighlights();
        }

        if (this.state.isHOCRReady && this.state.wantToPrintPDF) {
            this.printToPDF();
        }
    }

    getCurrentDocument() {
        let doc = this.props.analyzedDocuments[this.props.id];
        doc = doc ? doc : {
            highlights: [],
            missingHighlights: [],
            segments: []
        };

        return doc;
    }

    filterHighlights() {
        if (this.state.filter == 0) this.setState({ highlights: this.getCurrentDocument().highlights });
        else if (this.state.filter == 1) this.setState({ highlights: this.getCurrentDocument().highlights.filter(x => x.isSelected) });
    }

    handleClose() {
        this.setState({ show: false });
    }

    handleShow() {
        this.setState({ show: true });
    }

    handlePrintClick() {
        this.setState({ wantToPrintPDF: true });
    }

    printToPDF() {
        this.setState({ wantToPrintPDF: false });
        let element = document.getElementsByClassName('export-document-container')[0].children[0];
        Viewer.print(document, element);
    }

    handleExportAsWord() {
        this.props.exportAsDocx(this.props.id, this.state.visibleSections);
    }

    handleExportAsExcel = () => {
        this.props.exportAsExcel(this.props.id, this.state.visibleSections);
    }

    handleSectionToggle(value, type) {
        let visibleSections = [...this.state.visibleSections];
        if (value) visibleSections.push(type);
        else visibleSections = visibleSections.filter(x => x != type);
        visibleSections = [...new Set(visibleSections)];

        this.setState({ visibleSections });
    }

    handleSelectionToggle(value) {
        this.setState({ filter: value });
    }

    handleInitHOCR = () => {
        this.setState({ isHOCRReady: true });
    }

    getTooltip(text) {
        return (
            <Tooltip placement="right">
                {text}
            </Tooltip>
        );
    }

    render() {
        let doc = this.props.analyzedDocuments[this.props.id];
        let hasDoc = doc != null || doc != undefined;
        let hasContractType = hasDoc && doc.contractType != null && doc.contractType != undefined && doc.contractType != "Unknown";
        let isLoading = this.loadingListener.isLoading(this.props.isLoading);
        let showHOCR = this.state.wantToPrintPDF || this.state.isHOCRReady;

        return (
            <React.Fragment>
                {hasDoc &&
                    <div>
                        <OverlayTrigger overlay={this.getTooltip("Export document")}>
                            <div className="document-btn export-btn" onClick={this.handleShow}>
                                <Glyphicon glyph="download" />
                                <span className="highlight-count"><strong>{this.state.highlights.length}</strong></span>
                            </div>
                        </OverlayTrigger>

                        <Modal className="export-document-modal" show={this.state.show} onHide={this.handleClose}>
                            <Modal.Header closeButton>
                                <Modal.Title>Export options</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                {isLoading &&
                                    <LoadingIcon isFixed={false} />
                                }
                                {!isLoading && hasContractType &&
                                    <React.Fragment>
                                        <div className="panel-title-column">
                                            <span className="panel-title">What information should be included?</span>
                                        </div>
                                        <div className="section-toggles">
                                            <div>
                                                <span>Your notes</span>
                                                <ToggleSwitch initialValue={this.state.visibleSections.includes(HIGHLIGHT_SECTIONS.NOTES)} onChange={(v) => this.handleSectionToggle(v, HIGHLIGHT_SECTIONS.NOTES)} />
                                            </div>
                                            <div>
                                                <span>What to do</span>
                                                <ToggleSwitch initialValue={this.state.visibleSections.includes(HIGHLIGHT_SECTIONS.GUIDANCE)} onChange={(v) => this.handleSectionToggle(v, HIGHLIGHT_SECTIONS.GUIDANCE)} />
                                            </div>
                                            <div>
                                                <span>Example clauses</span>
                                                <ToggleSwitch initialValue={this.state.visibleSections.includes(HIGHLIGHT_SECTIONS.EXAMPLES)} onChange={(v) => this.handleSectionToggle(v, HIGHLIGHT_SECTIONS.EXAMPLES)} />
                                            </div>
                                            {doc.canExportToWord &&
                                                <div>
                                                    <span>Missing clauses</span>
                                                    <ToggleSwitch initialValue={this.state.visibleSections.includes(HIGHLIGHT_SECTIONS.MISSING_CLAUSES)} onChange={(v) => this.handleSectionToggle(v, HIGHLIGHT_SECTIONS.MISSING_CLAUSES)} />
                                                </div>
                                            }
                                        </div>
                                    </React.Fragment>
                                }
                                {!isLoading && !hasContractType &&
                                    <React.Fragment>
                                        <div className="panel-title-column">
                                            <span className="panel-title">Warning!</span>
                                        </div>
                                        <span>Cannot export document without a contract type. Go to contract overview to set one.</span>
                                    </React.Fragment>
                                }
                            </Modal.Body>
                            <Modal.Footer>
                                {hasContractType &&
                                    <React.Fragment>
                                        <Button onClick={this.handlePrintClick}>Print as PDF</Button>
                                        {doc.canExportToWord &&
                                            <Button onClick={this.handleExportAsWord}>Export to Word</Button>
                                        }
                                        <Button onClick={this.handleExportAsExcel}>Export to Excel</Button>
                                    </React.Fragment>
                                }
                                <Button onClick={this.handleClose}>Close</Button>
                            </Modal.Footer>
                        </Modal>

                        {showHOCR &&
                            <div className="export-document-container" style={{ visibility: 'hidden', height: '0', position: "absolute", display: 'none' }} >
                                <div className="export">
                                    <ExportHOCRView onInit={this.handleInitHOCR} />
                                    <h1>Appendix</h1>
                                    <HighlightExportTexts
                                        highlights={this.state.highlights}
                                        visibleSections={this.state.visibleSections}
                                        isLoading={this.props.isLoading}
                                    />
                                </div>
                            </div>
                        }
                    </div>
                }
            </React.Fragment>
        );
    }
}

export default connect(
    state => state.contractReviewer,
    dispatch => bindActionCreators(actions, dispatch)
)(ExportDocumentModal);


// WEBPACK FOOTER //
// ./src/components/Home/ExportDocumentModal.js